/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import { TableCell, TableRow } from "@mui/material";
import { Link, NavLink } from "react-router-dom";
import clsx from "clsx";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import ElipsisIcon from "../../../../../assets/images/icon_actions/Elipsis.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import { Image, Space, Dropdown, Menu } from "antd";
import { useDispatch, useSelector } from "react-redux";
import crudActions from "../../../../CRUD/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { toast } from 'react-toastify';
import moment from 'moment';
import { customerSelfBillHead } from "../../../../../config/constant";
import { capitalizeFirstLetter, currencyFormat, checkCRUDPermission, checkComponentPermission, getColumnWidth, downloadTitle, idNamingConversion } from "../../../../../helpers/utilities";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import InvoiceModal from "../../../../Shared/components/InvoiceModal";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { AESEncrypt } from "../../../../../helpers/Crypto";
import SearchText from '../../../../Shared/components/SearchText';


export const SelfBillTable = (props) => {
    const { details, onRequestSort, sortOrder, sortBy,
        hsnDetails, loadTasks, businessDetails, search, prefix,
        productGstdetails, loadMore, loadMoreTask, loadMoreContent, roleManagement } = props;
    const { editDetails, editError } = useSelector(state => state.crudReducer);
    const [billId, setBillId] = useState('');
    const [billDeleteId, setBillDeleteId] = useState('');
    //const [name, setName] = useState('');
    const dispatch = useDispatch();
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const classes = customStyles();
    const [open, setOpen] = useState(false);
    const [copy, setCopy] = useState(false);
    const [readDetails, setReadDetails] = useState([]);
    const [deleteModal, setDeleteModal] = useState(false);

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setBillId(data?.serialNo);
        setBillDeleteId(data?.id);
        // setName(data.name);
    }




    const handleStatus = (id, status) => {
        dispatch({
            type: crudActions.EDIT_DETAILS_START,
            url: 'selfBill',
            title: 'Sales Bill',
            id: id,
            details: {
                billStatus: status
            }
        });
    }

    const handleClose = (o) => (
        setOpen(o)
    );

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            //toast(editDetails);
            loadTasks();
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            // let message = editError.error.message;
            // toast.dismiss();
            // toast.error(message);
            let error = editError?.error?.message?.message || editError.error.message;
            toast.dismiss();
            toast.error(error);
        }
    }, [editDetails, editError]);

    const handleShareDocument = (data, copy) => {
        setOpen(true);
        setCopy(copy);
        setReadDetails(data);
        setBillId(data?.salesInvoice?.serialNo);
    }

    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={customerSelfBillHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                details={details}
                width={true}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={customerSelfBillHead.length}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                            <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell style={{ width: getColumnWidth(customerSelfBillHead, 0) }} >
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Sales Bill', 'view', 'Sales') ?
                                                            <Link id={idNamingConversion('View_' + data.id, 'salesBill', 'Link')} style={{ width: getColumnWidth(customerSelfBillHead, 0) }} to={`/sales/sales-management/self-bill/${AESEncrypt(data.id)}/view`}
                                                                className={clsx(classes.color, classes.bold)}>{data.serialNo ? data.serialNo : '---'}</Link>
                                                            : <span style={{ width: getColumnWidth(customerSelfBillHead, 0) }} >{data.serialNo ? data.serialNo : '---'}</span>
                                                    }
                                                </TableCell>
                                                <TableCell style={{ width: getColumnWidth(customerSelfBillHead, 1) }}><span style={{ width: getColumnWidth(customerSelfBillHead, 1) }} >{data?.name || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(customerSelfBillHead, 2) }}><span style={{ width: getColumnWidth(customerSelfBillHead, 2) }}>{data?.customer?.serialNo || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(customerSelfBillHead, 3) }}><span style={{ width: getColumnWidth(customerSelfBillHead, 3) }}>{data?.phone}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(customerSelfBillHead, 4) }} className={classes.rightAlignAmount}><span style={{ width: getColumnWidth(customerSelfBillHead, 4) }}>{'₹  '}{currencyFormat(data?.invoiceAmount)}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(customerSelfBillHead, 5) }}><span style={{ width: getColumnWidth(customerSelfBillHead, 5) }}>{moment(data?.invoiceDate).format('DD MMM YYYY')}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(customerSelfBillHead, 6) }}><span style={{ width: getColumnWidth(customerSelfBillHead, 6) }}>{moment(data?.dueDate).format('DD MMM YYYY')}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(customerSelfBillHead, 7) }}><span style={{ width: getColumnWidth(customerSelfBillHead, 7) }}>{moment(data?.createTs).format('DD MMM YYYY hh:mm A')}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(customerSelfBillHead, 8) }}><div className={clsx(classes.statusButton, { [classes.confirmedButton]: data.billStatus === 'CONFIRMED' },
                                                    { [classes.reversedButton]: data.billStatus === 'REVERSED' },
                                                    { [classes.cancelledButton]: data.billStatus === 'CANCELLED' })}>{capitalizeFirstLetter(data.billStatus)}</div>
                                                </TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={clsx(classes.iconPadding, classes.actionWidth)}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Sales Bill', 'view', 'Sales') &&
                                                            <Link id={idNamingConversion('View_' + data.id, 'salesBill', 'Icon')} to={`/sales/sales-management/self-bill/${AESEncrypt(data.id)}/view`}>
                                                                <Image src={ViewIcon} preview={false} />
                                                            </Link>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Sales Bill', 'edit', 'Sales') &&
                                                            <Link id={idNamingConversion('Edit_' + data.id, 'salesBill', 'Icon')} to={`/sales/sales-management/self-bill/${AESEncrypt(data.id)}/edit`}
                                                                className={clsx({ [classes.disabled]: data.billStatus !== 'CREATED' || data?.customer?.isHold })}>
                                                                <Image src={EditIcon} preview={false} />
                                                            </Link>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Sales Bill', 'deletable', 'Sales') &&
                                                            <NavLink id={idNamingConversion('Delete_' + data.id, 'salesBill', 'Icon')} to={"#"} className={clsx({ [classes.disabled]: data.billStatus !== 'CREATED' })} onClick={() => onDelete(data)}>
                                                                <Image src={DeleteIcon} preview={false} />
                                                            </NavLink>
                                                        }
                                                        <Dropdown
                                                            trigger={['click']}
                                                            placement={'bottomRight'}
                                                            overlay={
                                                                <Menu className={clsx(classes.groupMenu)}>
                                                                    {
                                                                        (data.billStatus === 'CONFIRMED' || data.billStatus === 'REVERSED' || data.billStatus === 'CANCELLED') ?
                                                                            <React.Fragment>
                                                                                <Menu.Item key={"Arrow"} className={clsx(classes.accordionSubmenuArrow)}></Menu.Item>
                                                                                {
                                                                                    roleManagement !== '' && checkComponentPermission('Sales Bill', 'Ellipsis Action', 'Share Document') &&
                                                                                    <><Menu.Item key={"View Document"}><NavLink to={'#'} id={idNamingConversion('View Document_' + data.id, 'salesBill', 'Link')} onClick={() => handleShareDocument(data, false)}>{data?.isViaNotification ? 'View Original' : 'View Original'}</NavLink></Menu.Item>
                                                                                        <Menu.Item key={"View Copy"}><NavLink to={'#'} id={idNamingConversion('View Copy_' + data.id, 'salesBill', 'Link')} onClick={() => handleShareDocument(data, 'Duplicate Copy')}>{data?.isViaNotification ? 'View Copy' : 'View Copy'}</NavLink></Menu.Item>
                                                                                        <Menu.Item key={"View Triplicate Copy"}><NavLink to={'#'} id={idNamingConversion('View Document_' + data.id, 'salesBill', 'Link')} onClick={() => handleShareDocument(data, 'Triplicate Copy')}>{data?.isViaNotification ? 'View Triplicate' : 'View Triplicate'}</NavLink></Menu.Item></>
                                                                                }
                                                                            </React.Fragment> : <React.Fragment>
                                                                                {
                                                                                    !data?.customer?.isHold &&
                                                                                    <>
                                                                                        {
                                                                                            roleManagement !== '' && checkComponentPermission('Sales Bill', 'Action', 'Confirm') && data.selfBillItems !== undefined &&
                                                                                            <><Menu.Item key={"Arrow"} className={clsx(data?.customer?.isHold)}></Menu.Item>
                                                                                                {
                                                                                                    <>
                                                                                                        {
                                                                                                            (prefix !== '' && (data?.manualInvoiceNo === '' || data?.manualInvoiceNo === null)) ? '' : <Menu.Item key={"Confirm"}><NavLink to={'#'} className={clsx({ [classes.disabled]: data.selfBillItems === undefined })} id={idNamingConversion('Confirm_' + data.id, 'salesBill', 'Link')} onClick={() => handleStatus(data.id, 'CONFIRMED')}>Confirm</NavLink></Menu.Item>
                                                                                                        }
                                                                                                    </>
                                                                                                }
                                                                                            </>
                                                                                        }
                                                                                    </>
                                                                                }
                                                                            </React.Fragment>
                                                                    }
                                                                </Menu>
                                                            }>
                                                            <Image
                                                                id={idNamingConversion('Ellipsis_' + data.id, 'salesBill', 'DropDown')}
                                                                src={ElipsisIcon}
                                                                preview={false}
                                                            />
                                                        </Dropdown>
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={customerSelfBillHead.length}>
                                                    {
                                                        search !== '' ? <SearchText /> : <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'All Sales Bill and Credit Notes will be listed here when transactions are recorded by the system'}</p>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </>
                }
            />
            {
                open && (
                    <>
                        <InvoiceModal open={open}
                            handleClose={(o) => handleClose(o)}
                            title={downloadTitle(readDetails, 'sales-bill')}
                            link={''}
                            copy={copy}
                            {...props}
                            businessDetails={businessDetails}
                            format={readDetails?.billFormat}
                            details={readDetails}
                            hsn={hsnDetails}
                            productGst={productGstdetails} />
                    </>
                )
            }
            <DeleteModal onClose={(v) => handleDeleteModal(v)} id={billDeleteId} loadTasks={() => loadTasks()}
                name={billId} url={'selfBill'} title={'Sales Bill'} visible={deleteModal} />
        </>
    )
}